import React from 'react';

const Searchbutton = ({searchByCharacter,searchByHouse}) =>{
    return(
        <div>
            <button onClick={searchByCharacter} className="Search__button">Search By Character</button>
            <button onClick={searchByHouse} className="Search__button">Search By House</button>
        </div>
    )
}

export default Searchbutton